//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';

var GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

var COLORS = {
  grey: 'btn-dark',
  transparent: 'btn-transparent'
};
export default {
  name: 'LandingImageText',
  components: {
    GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16;

      return {
        richText: ((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? _ref16.rich_text : _ref16 : _ref16) || [],
        textColor: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.text_color : _ref15 : _ref15) || '',
        image: {
          small: formatPrismicImage((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? (_ref14 = _ref14.image) != null ? (_ref14 = _ref14.medium) != null ? _ref14.url : _ref14 : _ref14 : _ref14 : _ref14, [['ar_16:9', 'c_fill'], 'w_375', 'dpr_2']) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? (_ref13 = _ref13.image) != null ? (_ref13 = _ref13.large) != null ? _ref13.url : _ref13 : _ref13 : _ref13 : _ref13, [['ar_16:9', 'c_fill'], 'w_720', 'dpr_2']) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? (_ref12 = _ref12.image) != null ? (_ref12 = _ref12.large) != null ? _ref12.url : _ref12 : _ref12 : _ref12 : _ref12, [['ar_16:9', 'c_fill'], 'w_800', 'dpr_2']) || EMPTY_PIXEL,
          xlarge: formatPrismicImage((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? (_ref11 = _ref11.image) != null ? (_ref11 = _ref11.xlarge) != null ? _ref11.url : _ref11 : _ref11 : _ref11 : _ref11, [['ar_16:9', 'c_fill'], 'w_1130', 'dpr_2']) || EMPTY_PIXEL,
          alt: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? _ref10.alt : _ref10 : _ref10) || ''
        },
        button: {
          style: COLORS[(_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? _ref9.button_style : _ref9 : _ref9],
          bg_color: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.button_color : _ref8 : _ref8) || '',
          text_color: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.button_text_color : _ref7 : _ref7) || '',
          text: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.button_text : _ref6 : _ref6) || '',
          url: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? (_ref5 = _ref5.button_url) != null ? _ref5.url : _ref5 : _ref5 : _ref5) || '',
          target: (_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.button_url) != null ? _ref4.target : _ref4 : _ref4 : _ref4,
          tracking: {
            data: {
              event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_category : _ref3 : _ref3) || '',
              event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_action : _ref2 : _ref2) || '',
              event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.event_label : _ref : _ref) || ''
            }
          }
        }
      };
    }

  }
};